import DefaultCard from "../components/exampleDefault/defaultCard/index";

const DefaultComponent = () => <DefaultCard />;

export default DefaultComponent;
